import { ref } from 'vue';
import type { Ref } from 'vue';

import type { UseModal } from '@/utils/useModal/useModal';

export enum SESSION_STATUS {
  ENDED = 'ended',
  STARTED = 'started',
  NEW_VERSION_DEPLOYED = 'deployed',
}

const showModal = ref(false);
const sessionStatus = ref(SESSION_STATUS.STARTED);

export interface UseSessionModal extends Omit<UseModal, 'open'> {
  open: (newSessionStatus: SESSION_STATUS) => void;
  sessionStatus: Ref<SESSION_STATUS>;
}

export const useSessionModal = (): UseSessionModal => {
  const open = (newSessionStatus: SESSION_STATUS): void => {
    sessionStatus.value = newSessionStatus;
    showModal.value = true;
  };
  const close = (): void => {
    showModal.value = false;
  };

  return {
    showModal,
    open,
    close,
    sessionStatus,
  };
};
